// Kept in its own dependency-free module, same pattern as raffleVisibility.ts, so it
// can be unit tested without pulling in RaffleContext.tsx's Firebase/location providers.
//
// This duplicates react-ui-components/utils/raffleZipAccess.ts on purpose: this app's
// react-ui-components dependency is pinned to a specific published commit, and that pin
// is re-pinned automatically once the library's ZIP work is released - this app can't
// import the shared helper yet. Once the pin updates, this local copy can be dropped.
export interface RaffleZipRestriction {
  allowedZip?: string | null
}

/**
 * Whether a raffle restricted to `allowedZip` should be visible/openable for a
 * user whose current location ZIP is `userZip`. An empty/missing `allowedZip`
 * means the raffle is unrestricted (existing behavior, unchanged). A raffle
 * restricted to a ZIP stays hidden for a user who has no ZIP set yet.
 */
export const isRaffleZipAllowed = (
  raffle: RaffleZipRestriction | null | undefined,
  userZip?: string | null,
): boolean => {
  const allowedZip = typeof raffle?.allowedZip === "string" ? raffle.allowedZip.trim() : ""
  if (!allowedZip || allowedZip === "*") {
    return true
  }

  const normalizedUserZip = (userZip || "").trim()
  if (!normalizedUserZip) {
    return false
  }

  return normalizedUserZip === allowedZip
}
